import { render, staticRenderFns } from "./salesDetails.vue?vue&type=template&id=57190c9d&scoped=true&"
import script from "./salesDetails.vue?vue&type=script&lang=js&"
export * from "./salesDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesDetails.vue?vue&type=style&index=0&id=57190c9d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57190c9d",
  null
  
)

export default component.exports